import React from 'react'
import MaterialSymbol from '../material-symbol'

const Room = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="room" {...props} />
))

Room.displayName = 'Room'

export default Room
